var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnclosedCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#fa1616;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.25A8.75,8.75,0,1,0,18.75,10,8.76,8.76,0,0,0,10,1.25Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.907,13.718a.625.625,0,0,1-.442-1.067l6.187-6.188a.625.625,0,1,1,.884.884L7.349,13.535a.626.626,0,0,1-.442.183Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.093,13.718a.62.62,0,0,1-.442-.183L6.464,7.348a.625.625,0,1,1,.884-.884l6.187,6.187a.625.625,0,0,1-.443,1.067Zm0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnclosedCloseIcon);
export default __webpack_public_path__ + "static/media/enclosed-close-icon.21a8e86b3568894fb2b9d6705430b8ff.svg";
export { ForwardRef as ReactComponent };